document.addEventListener('DOMContentLoaded', event => {

  document.addEventListener('click', event => {
    if (event.target.classList.contains('archive_month_link')) {
      event.preventDefault()
      event.target.parentElement.querySelector('ul.archive_month').classList.toggle('open')
    }

    if (event.target.classList.contains('archive_year_link')) {
      event.preventDefault()
      event.target.parentElement.querySelector('ul.archive_year').classList.toggle('open')
    }
  })
})
